//ios tech icons 
const iosAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const iosAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const iosAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const iosAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';

const iosServiceIcon1 = '/assets/Icons/TechIcons/iosTechIcons/ios-app-development-consulting.svg'
const iosServiceIcon2 = '/assets/Icons/TechIcons/iosTechIcons/custom-ios-app-development.svg'
const iosServiceIcon3 = '/assets/Icons/TechIcons/iosTechIcons/iwatch-app-development.svg'
const iosServiceIcon4 = '/assets/Icons/TechIcons/iosTechIcons/apple-tv-app-development.svg'
const iosServiceIcon5 = '/assets/Icons/TechIcons/iosTechIcons/ipad-app-development.svg'
const iosServiceIcon6 = '/assets/Icons/TechIcons/iosTechIcons/ios-app-ui_ux-design.svg'
const iosServiceIcon7 = '/assets/Icons/TechIcons/iosTechIcons/mvp-development.svg'
const iosServiceIcon8 = '/assets/Icons/TechIcons/iosTechIcons/ios-games-development.svg'
const iosServiceIcon9 = '/assets/Icons/TechIcons/iosTechIcons/ios-shopping-apps-development.svg'
const iosServiceIcon10 = '/assets/Icons/TechIcons/iosTechIcons/ios-business-apps-development.svg'
const iosServiceIcon11 = '/assets/Icons/TechIcons/iosTechIcons/ios-multimedia-apps-development.svg'
const iosServiceIcon12 = '/assets/Icons/TechIcons/iosTechIcons/native-ios-app-development-services.svg'
const iosServiceIcon13 = '/assets/Icons/TechIcons/iosTechIcons/enterprise-ios-app-development.svg'
const iosServiceIcon14 = '/assets/Icons/TechIcons/iosTechIcons/ios-app-upgrade-services.svg'
const iosServiceIcon15 = '/assets/Icons/TechIcons/iosTechIcons/ios-app-integration-and-migration.svg'
const iosServiceIcon16 = '/assets/Icons/TechIcons/iosTechIcons/on-demand-ios-developers.svg'
const iosServiceIcon17 = '/assets/Icons/TechIcons/iosTechIcons/quality-assurance-and-testing.svg'


//ror tech icons 
const rorAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const rorAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const rorAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const rorAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';


const rorServiceIcon1 = '/assets/Icons/TechIcons/rorTechIcons/ruby-on-rails-consulting.svg'
const rorServiceIcon2 = '/assets/Icons/TechIcons/rorTechIcons/custom-ror-web-app-development.svg'
const rorServiceIcon3 = '/assets/Icons/TechIcons/rorTechIcons/ruby-on-rails-portal-development.svg'
const rorServiceIcon4 = '/assets/Icons/TechIcons/rorTechIcons/rails-mvp-development.svg'
const rorServiceIcon5 = '/assets/Icons/TechIcons/rorTechIcons/ruby-on-rails-upgradation.svg'
const rorServiceIcon6 = '/assets/Icons/TechIcons/rorTechIcons/ror-team-augmentation-services.svg'
const rorServiceIcon7 = '/assets/Icons/TechIcons/rorTechIcons/product-api-development.svg'
const rorServiceIcon8 = '/assets/Icons/TechIcons/rorTechIcons/api-development-and-integration.svg'
const rorServiceIcon9 = '/assets/Icons/TechIcons/rorTechIcons/ruby-on-rails-migration-services.svg'
const rorServiceIcon10 = '/assets/Icons/TechIcons/rorTechIcons/ruby-on-rails-testing-and-qa.svg'
const rorServiceIcon11 = '/assets/Icons/TechIcons/rorTechIcons/post-deployment-support-and-maintenance.svg'

// java techservices
const javaAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const javaAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const javaAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const javaAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';

const javaServiceIcon1 = '/assets/Icons/TechIcons/javaTechIcons/java-web-development.svg';
const javaServiceIcon2 = '/assets/Icons/TechIcons/javaTechIcons/java-app-development.svg';
const javaServiceIcon3 = '/assets/Icons/TechIcons/javaTechIcons/java-software-development.svg';
const javaServiceIcon4 = '/assets/Icons/TechIcons/javaTechIcons/java-product-development.svg';
const javaServiceIcon5 = '/assets/Icons/TechIcons/javaTechIcons/java-desktop-app-development.svg';
const javaServiceIcon6 = '/assets/Icons/TechIcons/javaTechIcons/java-based-saas-app-development.svg';
const javaServiceIcon7 = '/assets/Icons/TechIcons/javaTechIcons/java-enterprise-software-development.svg';
const javaServiceIcon8 = '/assets/Icons/TechIcons/javaTechIcons/cross-platform-development-with-java.svg';
const javaServiceIcon9 = '/assets/Icons/TechIcons/javaTechIcons/java-software-modernization.svg';
const javaServiceIcon10 = '/assets/Icons/TechIcons/javaTechIcons/team-augmentation-with-java-experts.svg';
const javaServiceIcon11 = '/assets/Icons/TechIcons/javaTechIcons/java-application-migration.svg';
const javaServiceIcon12 = '/assets/Icons/TechIcons/javaTechIcons/java-cloud-development.svg';
const javaServiceIcon13 = '/assets/Icons/TechIcons/javaTechIcons/java-for-iot.svg';
const javaServiceIcon14 = '/assets/Icons/TechIcons/javaTechIcons/java-microservices-development.svg';
const javaServiceIcon15 = '/assets/Icons/TechIcons/javaTechIcons/java-api-development.svg';
const javaServiceIcon16 = '/assets/Icons/TechIcons/javaTechIcons/java-cms-development.svg';
const javaServiceIcon17 = '/assets/Icons/TechIcons/javaTechIcons/java-maintenance-&-support.svg';


// android tech icons 
const androidAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const androidAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const androidAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const androidAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';

const androidServicesIcon1 = '/assets/Icons/TechIcons/androidTechIcons/android-app-development-consulting.svg';
const androidServicesIcon2 = '/assets/Icons/TechIcons/androidTechIcons/android-mobile-app-development.svg';
const androidServicesIcon3 = '/assets/Icons/TechIcons/androidTechIcons/android-wearable-app-development.svg';
const androidServicesIcon4 = '/assets/Icons/TechIcons/androidTechIcons/enterprise-android-app-development.svg';
const androidServicesIcon5 = '/assets/Icons/TechIcons/androidTechIcons/on-demand-android-app-developers.svg';
const androidServicesIcon6 = '/assets/Icons/TechIcons/androidTechIcons/android-tv-app-development.svg';
const androidServicesIcon7 = '/assets/Icons/TechIcons/androidTechIcons/android-tablet-app-development.svg';
const androidServicesIcon8 = '/assets/Icons/TechIcons/androidTechIcons/android-app-modernization.svg';
const androidServicesIcon9 = '/assets/Icons/TechIcons/androidTechIcons/android-app-ux_ui-design.svg';
const androidServicesIcon10 = '/assets/Icons/TechIcons/androidTechIcons/android-app-testing-and-qa.svg';
const androidServicesIcon11 = '/assets/Icons/TechIcons/androidTechIcons/app-support-and-maintenance.svg';




// python tech icons
const pythonAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const pythonAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const pythonAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const pythonAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';



const pythonServicesIcon1 = '/assets/Icons/TechIcons/pythonTechIcons/python-consulting-services.svg';
const pythonServicesIcon2 = '/assets/Icons/TechIcons/pythonTechIcons/python-enterprise-solutions.svg';
const pythonServicesIcon3 = '/assets/Icons/TechIcons/pythonTechIcons/python-software-development.svg'
const pythonServicesIcon4 = '/assets/Icons/TechIcons/pythonTechIcons/python-mobile-app-development.svg';
const pythonServicesIcon5 = '/assets/Icons/TechIcons/pythonTechIcons/python-web-app-development.svg';
const pythonServicesIcon6 = '/assets/Icons/TechIcons/pythonTechIcons/custom-python-development.svg';
const pythonServicesIcon7 = '/assets/Icons/TechIcons/pythonTechIcons/cloud-based-python-solutions.svg';
const pythonServicesIcon8 = '/assets/Icons/TechIcons/pythonTechIcons/prototyping-and-mvp-development.svg'
const pythonServicesIcon9 = '/assets/Icons/TechIcons/pythonTechIcons/python-game-development.svg';
const pythonServicesIcon10 = '/assets/Icons/TechIcons/pythonTechIcons/python-django-framework-development.svg';
const pythonServicesIcon11 = '/assets/Icons/TechIcons/pythonTechIcons/python-cms-development.svg';
const pythonServicesIcon12 = '/assets/Icons/TechIcons/pythonTechIcons/python-api-development-and-integration.svg';
const pythonServicesIcon13 = '/assets/Icons/TechIcons/pythonTechIcons/python-machine-learning.svg';
const pythonServicesIcon14 = '/assets/Icons/TechIcons/pythonTechIcons/python-migration-services.svg';
const pythonServicesIcon15 = '/assets/Icons/TechIcons/pythonTechIcons/python-ai-ml-solutions.svg';
const pythonServicesIcon16 = '/assets/Icons/TechIcons/pythonTechIcons/natural-language-processing.svg';
const pythonServicesIcon17 = '/assets/Icons/TechIcons/pythonTechIcons/python-iot-solutions.svg';
const pythonServicesIcon18 = '/assets/Icons/TechIcons/pythonTechIcons/data-science-and-analytics.svg';




// .NET tech icon 
const dotNetAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const dotNetAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const dotNetAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const dotNetAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';


const dotNetServicesIcon1 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-consulting.svg';
const dotNetServicesIcon2 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-web-development.svg';
const dotNetServicesIcon3 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-mobile-development.svg';
const dotNetServicesIcon4 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-core-development.svg';
const dotNetServicesIcon5 = '/assets/Icons/TechIcons/dotNetTechIcons/custom-dot-net-application-development.svg';
const dotNetServicesIcon6 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-desktop-app-development.svg';
const dotNetServicesIcon7 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-enterprise-solutions.svg';
const dotNetServicesIcon8 = '/assets/Icons/TechIcons/dotNetTechIcons/full-stack-dot-net-development.svg';
const dotNetServicesIcon9 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-software-development.svg'
const dotNetServicesIcon10 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-product-development.svg';
const dotNetServicesIcon11 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-cloud-integration.svg';
const dotNetServicesIcon12 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-e-commerce-solutions.svg';
const dotNetServicesIcon13 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-cms-app-development.svg'
const dotNetServicesIcon14 = '/assets/Icons/TechIcons/dotNetTechIcons/dedicated-dot-net-development-team.svg';
const dotNetServicesIcon15 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-migration-and-upgradation.svg';
const dotNetServicesIcon16 = '/assets/Icons/TechIcons/dotNetTechIcons/dot-net-maintenance-and-support.svg';

// react native tech icons
const reactNativeAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const reactNativeAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const reactNativeAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const reactNativeAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';

const reactNativeServiceseIcon1 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-consulting.svg'
const reactNativeServiceseIcon2 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-ios-app-development.svg';
const reactNativeServiceseIcon3 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-android-app-development.svg';
const reactNativeServiceseIcon4 = '/assets/Icons/TechIcons/reactNativeTechIcons/custom-react-native-app-development.svg';
const reactNativeServiceseIcon5 = '/assets/Icons/TechIcons/reactNativeTechIcons/cross-platform-react-native-app-development.svg';
const reactNativeServiceseIcon6 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-mvp-development.svg';
const reactNativeServiceseIcon7 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-code-auditing.svg';
const reactNativeServiceseIcon8 = '/assets/Icons/TechIcons/reactNativeTechIcons/ui-ux-design-for-react-native-apps.svg';
const reactNativeServiceseIcon9 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-integration-and-migration.svg';
const reactNativeServiceseIcon10 = '/assets/Icons/TechIcons/reactNativeTechIcons/third-party-api-integration.svg';
const reactNativeServiceseIcon11 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-team-augmentation.svg'
const reactNativeServiceseIcon12 = '/assets/Icons/TechIcons/reactNativeTechIcons/react-native-app-testing-and-qa.svg'
const reactNativeServiceseIcon13 = '/assets/Icons/TechIcons/reactNativeTechIcons/support-and-maintenance-services.svg'

// php 
const phpAgileIcon1 = '/assets/Icons/TechIcons/iosTechIcons/flexibility-with-agile-methodology.svg';
const phpAgileIcon2 = '/assets/Icons/TechIcons/iosTechIcons/high-privacy-with-nda.svg';
const phpAgileIcon3 = '/assets/Icons/TechIcons/iosTechIcons/time-zone-aligned-development.svg';
const phpAgileIcon4 = '/assets/Icons/TechIcons/iosTechIcons/quick-onboarding-within-48-hours.svg';

const phpServicesIcons1 = '/assets/Icons/TechIcons/phpTechIcons/php-app-development.svg';
const phpServicesIcons2 = '/assets/Icons/TechIcons/phpTechIcons/php-web-development.svg';
const phpServicesIcons3 = '/assets/Icons/TechIcons/phpTechIcons/e-commerce-php-development.svg';
const phpServicesIcons4 = '/assets/Icons/TechIcons/phpTechIcons/backend-architecture-services.svg';
const phpServicesIcons5 = '/assets/Icons/TechIcons/phpTechIcons/full-stack-php-development.svg';
const phpServicesIcons6 = '/assets/Icons/TechIcons/phpTechIcons/php-framework-development.svg';
const phpServicesIcons7 = '/assets/Icons/TechIcons/phpTechIcons/php-portal-development.svg';
const phpServicesIcons8 = '/assets/Icons/TechIcons/phpTechIcons/custom-crm-erp-and-portal-development.svg';
const phpServicesIcons9 = '/assets/Icons/TechIcons/phpTechIcons/cms-development.svg';
const phpServicesIcons10 = '/assets/Icons/TechIcons/phpTechIcons/social-networking-solutions.svg';
const phpServicesIcons11 = '/assets/Icons/TechIcons/phpTechIcons/ai-powered-php-solutions.svg';
const phpServicesIcons12 = '/assets/Icons/TechIcons/phpTechIcons/cloud-application-solutions.svg';
const phpServicesIcons13 = '/assets/Icons/TechIcons/phpTechIcons/database-development-services.svg';
const phpServicesIcons14 = '/assets/Icons/TechIcons/phpTechIcons/php-api-development-and-integration.svg';
const phpServicesIcons15 = '/assets/Icons/TechIcons/phpTechIcons/php-upgradation-and-migration.svg';
const phpServicesIcons16 = '/assets/Icons/TechIcons/phpTechIcons/php-security-audits.svg';
const phpServicesIcons17 = '/assets/Icons/TechIcons/phpTechIcons/dedicated-php-developers.svg';
const phpServicesIcons18 = '/assets/Icons/TechIcons/phpTechIcons/php-website-support-and-maintenance.svg';




export const icons = {
    iosAgileIcon1,
    iosAgileIcon2,
    iosAgileIcon3,
    iosAgileIcon4,

    iosServiceIcon1,
    iosServiceIcon2,
    iosServiceIcon3,
    iosServiceIcon4,
    iosServiceIcon5,
    iosServiceIcon6,
    iosServiceIcon7,
    iosServiceIcon8,
    iosServiceIcon9,
    iosServiceIcon10,
    iosServiceIcon11,
    iosServiceIcon12,
    iosServiceIcon13,
    iosServiceIcon14,
    iosServiceIcon15,
    iosServiceIcon16,
    iosServiceIcon17,

    //ror tech isonc
    rorAgileIcon1,
    rorAgileIcon2,
    rorAgileIcon3,
    rorAgileIcon4,

    rorServiceIcon1,
    rorServiceIcon2,
    rorServiceIcon3,
    rorServiceIcon4,
    rorServiceIcon5,
    rorServiceIcon6,
    rorServiceIcon7,
    rorServiceIcon8,
    rorServiceIcon9,
    rorServiceIcon10,
    rorServiceIcon11,

    //java tech icons
    javaAgileIcon1,
    javaAgileIcon2,
    javaAgileIcon3,
    javaAgileIcon4,
    javaServiceIcon1,
    javaServiceIcon2,
    javaServiceIcon3,
    javaServiceIcon4,
    javaServiceIcon5,
    javaServiceIcon6,
    javaServiceIcon7,
    javaServiceIcon8,
    javaServiceIcon9,
    javaServiceIcon10,
    javaServiceIcon11,
    javaServiceIcon12,
    javaServiceIcon13,
    javaServiceIcon14,
    javaServiceIcon15,
    javaServiceIcon16,
    javaServiceIcon17,

    //android  icons 
    androidAgileIcon1,
    androidAgileIcon2,
    androidAgileIcon3,
    androidAgileIcon4,
    androidServicesIcon1,
    androidServicesIcon2,
    androidServicesIcon3,
    androidServicesIcon4,
    androidServicesIcon5,
    androidServicesIcon6,
    androidServicesIcon7,
    androidServicesIcon8,
    androidServicesIcon9,
    androidServicesIcon10,
    androidServicesIcon11,


    // pyhton tech icons
    pythonAgileIcon1,
    pythonAgileIcon2,
    pythonAgileIcon3,
    pythonAgileIcon4,

    pythonServicesIcon1,
    pythonServicesIcon2,
    pythonServicesIcon3,
    pythonServicesIcon4,
    pythonServicesIcon5,
    pythonServicesIcon6,
    pythonServicesIcon7,
    pythonServicesIcon8,
    pythonServicesIcon9,
    pythonServicesIcon10,
    pythonServicesIcon11,
    pythonServicesIcon12,
    pythonServicesIcon13,
    pythonServicesIcon14,
    pythonServicesIcon15,
    pythonServicesIcon16,
    pythonServicesIcon17,
    pythonServicesIcon18,

    // dot-net 
    dotNetAgileIcon1,
    dotNetAgileIcon2,
    dotNetAgileIcon3,
    dotNetAgileIcon4,

    dotNetServicesIcon1,
    dotNetServicesIcon2,
    dotNetServicesIcon3,
    dotNetServicesIcon4,
    dotNetServicesIcon5,
    dotNetServicesIcon6,
    dotNetServicesIcon7,
    dotNetServicesIcon8,
    dotNetServicesIcon9,
    dotNetServicesIcon10,
    dotNetServicesIcon11,
    dotNetServicesIcon12,
    dotNetServicesIcon13,
    dotNetServicesIcon14,
    dotNetServicesIcon15,
    dotNetServicesIcon16,

    // react-native
    reactNativeAgileIcon1,
    reactNativeAgileIcon2,
    reactNativeAgileIcon3,
    reactNativeAgileIcon4,

    reactNativeServiceseIcon1,
    reactNativeServiceseIcon2,
    reactNativeServiceseIcon3,
    reactNativeServiceseIcon4,
    reactNativeServiceseIcon5,
    reactNativeServiceseIcon6,
    reactNativeServiceseIcon7,
    reactNativeServiceseIcon8,
    reactNativeServiceseIcon9,
    reactNativeServiceseIcon10,
    reactNativeServiceseIcon11,
    reactNativeServiceseIcon12,
    reactNativeServiceseIcon13,

    // php 
    phpAgileIcon1,
    phpAgileIcon2,
    phpAgileIcon3,
    phpAgileIcon4,
    phpServicesIcons1,
    phpServicesIcons2,
    phpServicesIcons3,
    phpServicesIcons4,
    phpServicesIcons5,
    phpServicesIcons6,
    phpServicesIcons7,
    phpServicesIcons8,
    phpServicesIcons9,
    phpServicesIcons10,
    phpServicesIcons11,
    phpServicesIcons12,
    phpServicesIcons13,
    phpServicesIcons14,
    phpServicesIcons15,
    phpServicesIcons16,
    phpServicesIcons17,
    phpServicesIcons18,

};
